import React from 'react';
import { Button } from 'Components';
import { Icons } from 'Assets';
import { useEffectOnce } from 'Hooks';

interface Props {
  title?: string;

  cancelTitle?: string;
  onCancelClick?: React.MouseEventHandler<HTMLButtonElement>;

  confirmTitle?: string;
  onConfirmClick?: React.MouseEventHandler<HTMLButtonElement>;

  onCloseClick?: React.MouseEventHandler<HTMLDivElement>;
  onLoad?: () => void;

  children: React.ReactNode;
  popinWidth?: string;
}

export const Popin: React.FC<Props> = ({
  title,
  cancelTitle,
  onCancelClick,
  confirmTitle,
  onConfirmClick,
  onCloseClick,
  onLoad,
  children,
  popinWidth = '',
}) => {
  useEffectOnce(() => {
    onLoad && onLoad();
    const htmlBodyElement = document.querySelector('body');
    if (htmlBodyElement) htmlBodyElement.style.overflow = 'hidden';
    return () => {
      htmlBodyElement && htmlBodyElement.style.removeProperty('overflow');
    };
  });

  return (
    <>
      <div className="w-screen h-screen bg-dark-gray bg-opacity-70 fixed top-0 left-0" onClick={onCloseClick} />
      <div
        className={`w-full bg-white p-4 fixed left-0 bottom-0 md:left-1/2 md:bottom-1/2 md:-translate-x-1/2 md:translate-y-1/2
          md:max-w-[650px] md:border-whitesmoke md:border md:rounded md:p-6 ${popinWidth}`}
        onClick={(e) => e.stopPropagation()}
      >
        {onCloseClick && (
          <img
            src={Icons.CrossWhite}
            alt="Fermer"
            className="absolute -top-6 right-3 md:right-1 h-3 w-3 cursor-pointer"
            onClick={onCloseClick}
          />
        )}

        {title && (
          <>
            <h1 className="text-lg font-bold text-nero">{title}</h1>

            <hr className="text-whitesmoke mt-2 mb-5" />
          </>
        )}

        {children}

        {(cancelTitle || confirmTitle) && (
          <div className="flex gap-2 justify-end mt-5 md:gap-4 text-base flex-col md:flex-row">
            {confirmTitle && (
              <Button className="md:w-fit px-6 py-[10px]" onClick={onConfirmClick}>
                {confirmTitle}
              </Button>
            )}

            {cancelTitle && (
              <Button className="md:w-fit px-6 py-[10px]" onClick={onCancelClick} variant="primary">
                {cancelTitle}
              </Button>
            )}
          </div>
        )}
      </div>
    </>
  );
};
